<template>
  <div class="calendar-container">
    <DayPilotCalendar ref="calendar" :config="calendarConfig" />
  </div>
</template>

<script>
import { DayPilotCalendar } from "@daypilot/daypilot-lite-vue";

export default {
  components: {
    DayPilotCalendar,
  },
  props: {
    events: Array,
    resources: Array,
  },
  data() {
    return {
      calendarConfig: {
        viewType: "Resources",
        eventMoveHandling: "Disabled",
        eventResizeHandling: "Disabled",
        startDate: new Date(),
        headerDateFormat: "dddd, MMM d, yyyy",
        timeFormat: "Clock24Hours",
        columns: this.resources || [],
        events: this.events || [],
        cellHeight: 65,
        onEventClick: (args) => {
          const route = this.$router.resolve({
            name: "DetailBooking",
            query: { id: args.e.data.id },
          });
          window.open(route.href, "_blank");
        },
      },
    };
  },
};
</script>
